import React from "react";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import CommonSelect from "../../../../core/common/commonSelect";

interface ActionButtonsProps {
  companyOptions: any[];
  selectedCompanyOption: any;
  isLoadingCompanies: boolean;
  isEmployee: boolean;
  isEditMode: boolean;
  isSaving: boolean;
  selectedCompany: any;
  selectedConfiguration: any;
  onCompanySelection: (selectedOption: any) => void;
  onEdit: () => void;
  onSave: () => void;
  onDelete: (id: string) => void;
  onClose: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  companyOptions,
  selectedCompanyOption,
  isLoadingCompanies,
  isEmployee,
  isEditMode,
  isSaving,
  selectedCompany,
  selectedConfiguration,
  onCompanySelection,
  onEdit,
  onSave,
  onDelete,
  onClose,
}) => {
  return (
    <div
      className="d-flex my-xl-auto right-content align-items-center flex-wrap"
      title="Select Company">
      <CommonSelect
        className="select mb-2 me-2"
        options={companyOptions}
        defaultValue={selectedCompanyOption || undefined}
        onChange={onCompanySelection}
        placeHolder={
          isLoadingCompanies ? "Loading companies..." : "Select Company"
        }
        isDisabled={isLoadingCompanies || isEmployee}
      />

      <div className="me-2 mb-2">
        {!isEditMode ? (
          <button
            title="Edit Dashboard"
            className="btn btn-sm btn-info px-3 py-2 d-flex align-items-center"
            onClick={onEdit}
            disabled={!selectedCompany}>
            <i className="ti ti-pencil me-1" />
            Edit Dashboard
          </button>
        ) : (
          <div className="d-flex gap-2">
            <button
              title="Save Dashboard"
              className="btn btn-sm btn-info px-3 py-2 d-flex align-items-center"
              onClick={onSave}
              disabled={isSaving}>
              {isSaving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" />
                  Saving...
                </>
              ) : (
                <>
                  <i className="ti ti-device-floppy me-1" />
                  Save
                </>
              )}
            </button>
            {selectedConfiguration && selectedConfiguration.id !== "-1" && (
              <button
                className="btn btn-sm btn-outline-danger px-3 py-2 d-flex align-items-center"
                onClick={() => onDelete(selectedConfiguration.id.toString())}
                title="Delete Configuration">
                <i className="ti ti-trash me-1" />
                Delete
              </button>
            )}
            <button
              title="Close Dashboard Editor"
              className="btn btn-sm btn-outline-danger px-3 py-2 d-flex align-items-center"
              onClick={onClose}
              disabled={isSaving}>
              <i className="ti ti-x me-1" />
              Close
            </button>
          </div>
        )}
      </div>

      <div className="head-icons">
        <CollapseHeader />
      </div>
    </div>
  );
};

export default ActionButtons;
